import { FormInput } from "components/ProjectNonSpecificComponents/Elements/FormElements/FormInput"
import Whitespace from "components/ProjectNonSpecificComponents/Elements/Whitespace"
import { useFormStore } from "components/ProjectSpecificComponents/Contexts/FormStoreContext"
import { useStore } from "components/ProjectSpecificComponents/Contexts/GlobalStoreContext"
import { observer } from "mobx-react"
import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import Checkbox from "../../atoms/Checkbox"

const CookieBarConfig = observer(() => {
	const [stringToRichText, setStringToRichText] = useState<boolean>(false)
	const store = useStore()
	const formStore = useFormStore()
	const { t } = useTranslation()
	const { settingsLanguage } = formStore
	// ! TECHNICAL DEBT: 3184, replace this with dynamic key ([parsedkey])
	let isEN = settingsLanguage == "en"
	const { cookieBar } = formStore.settingsData.additionalInfo

	useEffect(() => {
		setStringToRichText(true)
	}, [settingsLanguage])

	return (
		<div className="px-4 py-2">
			<div className="flex flex-row whitespace-nowrap w-full pb-2 justify-between">
				<p className="text-sm pr-1 pt-1">{t(`forms.field-label.cookie-bar`)}</p>
				<div className="flex flex-row justify-between">
						<p className="text-sm pr-1 pt-1">{t("rawText.modal-window")}</p>
						<Checkbox
							checked={cookieBar?.isModal ?? false}
							onCheck={(checked) => {
								formStore.mergeUserFormWelcomeTextData({
									cookieBar: {
										...cookieBar,
										isModal: checked,
									},
								})
							}}
						/>
				        <Whitespace h x="1" />
						<p className="text-sm pr-1 pt-1">{t("rawText.rich-text")}</p>
						<Checkbox
							checked={cookieBar?.isRichText ?? false}
							onCheck={(checked) => {
								formStore.mergeUserFormWelcomeTextData({
									cookieBar: {
										...cookieBar,
										isRichText: checked,
									},
								})
							}}
						/>
				</div>
			</div>

			<FormInput
				multiline
				wide
				value={isEN ? cookieBar?.textEN ?? "" : cookieBar?.textLV ?? ""}
				onValueChange={(text) =>
					formStore.mergeUserFormWelcomeTextData(
						isEN
							? {
									cookieBar: {
										...cookieBar,
										textEN: text,
									},
							  }
							: {
									cookieBar: {
										...cookieBar,
										textLV: text,
									},
							  }
					)
				}
				richText={cookieBar?.isRichText}
				convertStringToHTML={stringToRichText}
				resetConvertStringToHTMLValue={() => setStringToRichText(false)}
			/>
		</div>
	)
})

export default CookieBarConfig
